import { Slide } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import AnimatedDots from '../animated-dots/AnimatedDots';

import scss from './NotificationBar.module.scss';

function NotificationBar() {
  const { t } = useTranslation('notifications');
  const status = useSelector((state) => state.notifier.notificationStatus);

  return (
    <Slide direction='down' in={!!status} mountOnEnter unmountOnExit>
      <div className={scss.wrapper}>
        <span>{t(status)}</span>
        <AnimatedDots size='4px' color='var(--notification-bar-text)' />
      </div>
    </Slide>
  );
}

export default NotificationBar;
